import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import { AppButton, Modal } from '@/components'
import { ContactEllipses } from '@/assets/icons'
import { openLink } from '@/utils'
import { links } from '@/constants/links'
import { UpdateInfoModalProps } from './types'

export const UpdateInfoModal: React.FC<UpdateInfoModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation()

  const handleContactSupport = () => {
    openLink(links.support)
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} showHandle={true}>
      <BaseView
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 24,
          paddingTop: 16,
          paddingBottom: 34,
        }}
      >
        {/* Icon */}
        <ContactEllipses size={110} />

        {/* Content */}
        <BaseView
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 16,
            paddingLeft: 16,
            paddingRight: 16,
          }}
        >
          {/* Title */}
          <BaseText
            fontSize={24}
            fontFamily="semibold"
            color="label.default"
            textAlign="center"
          >
            {t('bottomSheets:updateYourInfo.title')}
          </BaseText>

          {/* Description */}
          <BaseText
            fontSize={16}
            fontFamily="regular"
            color="label.secondary"
            textAlign="center"
            style={{
              lineHeight: '22px',
            }}
          >
            {t('bottomSheets:updateYourInfo.description')}
          </BaseText>
        </BaseView>

        {/* Contact Support Link */}
        <div
          style={{
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
          onClick={handleContactSupport}
        >
          <BaseText
            fontSize={16}
            fontFamily="medium"
            color="accent.primary"
            textAlign="center"
          >
            {t('links:contactSupport')}
          </BaseText>
        </div>

        {/* Okay Button */}
        <BaseView style={{ width: '100%', paddingLeft: 16, paddingRight: 16 }}>
          <AppButton
            type="secondaryGray"
            label={t('form:actions.okay')}
            onPress={onClose}
          />
        </BaseView>
      </BaseView>
    </Modal>
  )
}
